const IS_PROD_ENV: Boolean = process.env.VUE_APP_IS_PROD_ENV === 'true'
const API_URL: string = (process.env.VUE_APP_API_URL || '') as string
const API_V2_URL: string = (process.env.VUE_APP_API_V2_URL || 'http://localhost:34337') as string
const FRONTEND_V2_URL: string = (process.env.VUE_APP_FRONTEND_V2_URL || 'http://localhost:4200') as string

export default {
  is_Prod_Env () {
    return IS_PROD_ENV
  },

  get_API_URL () {
    return API_URL
  },

  get_API_V2_URL () {
    return API_V2_URL
  },

  get_FRONTEND_V2_URL () {
    return FRONTEND_V2_URL
  }
}
